// Funções de formatação usadas nos cards/gráficos do overview.

// Inverte o sinal da potência RX conforme configuração do tenant.
export const INVERSED_POWER_RX =
  window?.config?.REACT_APP_INVERSED_POWER_RX ||
  process.env.REACT_APP_INVERSED_POWER_RX;

export function formatTraffic(valueInBytesPerSecond) {
  //////// Verificar demais amostras
  const KB = 1000;
  const MB = KB * 1000;
  const GB = MB * 1000;

  const value = Number(valueInBytesPerSecond);

  if (value < MB) {
    return `${(value / KB).toFixed(1)} KB/s`;
  } else if (value < GB) {
    return `${(value / MB).toFixed(2)} MB/s`;
  } else {
    return `${(value / GB).toFixed(2)} GB/s`;
  }
}

export function formatPing(valueInSeconds) {
  return `${(Number(valueInSeconds) * 1000).toFixed(0)} ms`;
}

export function formatSessions(value) {
  if (value == null || isNaN(Number(value))) return "0";
  return Number(value).toLocaleString("pt-BR");
}

export function formatPowerValue(value) {
  if (value === null || value === undefined || value === "") return "0 dBm";
  const num = Number(value);
  if (isNaN(num)) return `${value} dBm`;
  return `${INVERSED_POWER_RX ? -num.toFixed(0) : num.toFixed(0)} dBm`;
}

export function formatPacketLoss(value) {
  return `${Number(value).toFixed(1)}%`;
}
